module.exports = __webpack_public_path__ + "static/img/bluebgc.58b02cf5.jpg";